var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PremiumPattern } from './PremiumPattern';
import { ProductService } from '@app/shared/services/product.service';
var PremiumPatternFactory = /** @class */ (function () {
    function PremiumPatternFactory(injector) {
        this.injector = injector;
    }
    Object.defineProperty(PremiumPatternFactory.prototype, "productService", {
        get: function () {
            if (!this._productService) {
                this._productService = this.injector.get(ProductService);
            }
            return this._productService;
        },
        enumerable: true,
        configurable: true
    });
    PremiumPatternFactory.prototype.withMetadata = function (premiumPatternId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.productService.getPremiumPatternSet(premiumPatternId).toPromise()];
                    case 1:
                        _a.metaData$ = _b.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    PremiumPatternFactory.prototype.extractPremiumPatternUIDList = function () {
        return this.metaData$.PremiumPatterns.map(function (_a) {
            var UID = _a.UID;
            return ({ UID: UID }.UID);
        });
    };
    PremiumPatternFactory.prototype.forPremiumPattern = function (premiumPatternUID) {
        this.PremiumPattern = this.metaData$.PremiumPatterns.find(function (x) { return x.UID === premiumPatternUID; });
        return this;
    };
    PremiumPatternFactory.prototype.extractUID = function () {
        this.UID = this.PremiumPattern.UID;
        return this;
    };
    PremiumPatternFactory.prototype.extractPremiumIncreaseIndex = function () {
        if (this.PremiumPattern.PremiumEscalationType) {
            if (this.PremiumPattern.IndexLinkedPremium && this.PremiumPattern.IndexLinkedPremium.Index) {
                this.PremiumIncreaseIndex = this.PremiumPattern.IndexLinkedPremium.Index.Name;
                return this;
            }
            this.PremiumIncreaseIndex = this.PremiumPattern.PremiumEscalationType;
            return this;
        }
    };
    PremiumPatternFactory.prototype.extractPremiumIncrease = function () {
        this.PremiumIncrease = 0;
        if (this.PremiumPattern.FixedIncreasePremium && this.PremiumPattern.FixedIncreasePremium.OverallEscalation) {
            this.PremiumIncrease = this.PremiumPattern.FixedIncreasePremium.OverallEscalation;
            if (this.PremiumIncreaseIndex.toLocaleLowerCase() === 'cpi') {
                this.PremiumIncrease = 'CPI + ' + this.PremiumIncrease;
            }
            return this;
        }
        if (this.PremiumPattern.IndexLinkedPremium && this.PremiumPattern.IndexLinkedPremium.AdditionalEscalation !== undefined && this.PremiumPattern.IndexLinkedPremium.AdditionalEscalation !== null) {
            this.PremiumIncrease = this.PremiumPattern.IndexLinkedPremium.AdditionalEscalation;
            if (this.PremiumIncreaseIndex.toLocaleLowerCase() === 'cpi') {
                this.PremiumIncrease = 'CPI + ' + this.PremiumIncrease;
            }
            return this;
        }
        return this;
    };
    PremiumPatternFactory.prototype.extractPremiumTerm = function () {
        if (this.PremiumPattern.CeaseAge) {
            this.PremiumTerm = this.PremiumPattern.CeaseAge;
            if (this.PremiumTerm.toString().toLocaleLowerCase().indexOf('cover') >= 0) {
                this.PremiumTerm = 'same as benefit term';
            }
            return this;
        }
    };
    PremiumPatternFactory.prototype.build = function () {
        return new PremiumPattern(this.PremiumPattern.UID, this.PremiumIncreaseIndex, this.PremiumIncrease, this.PremiumTerm);
    };
    return PremiumPatternFactory;
}());
export { PremiumPatternFactory };
